module.exports = __webpack_public_path__ + "static/media/gallery_09.6df80cc4.png";